(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moving-background-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const movingImageGroups = document.querySelectorAll('[data-moving-image-group]');

    movingImageGroups.forEach((group) => {
      // Intersection Observer to pause animation when not in viewport
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.remove('moving-image-group--paused');
            } else {
              entry.target.classList.add('moving-image-group--paused');
            }
          });
        },
        {
          threshold: 0.1,
        }
      );

      observer.observe(group);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
